const mutations = {
  /**
   * Toggle the sidebarVisible property. If sidebarVisible
   * is true, the new value will be false and if value is
   * false, the new value will be true.
   *
   * @param state
   */
  toggleSidebarVisible(state) {
    state.sidebarVisible = !state.sidebarVisible;
  },

  /**
   * Hide side bar defining the property
   * sidebarVisible with false value.
   *
   * @param state
   */
  hideSidebar(state) {
    state.sidebarVisible = false;
  },

  /**
   * Show side bar defining the property
   * sidebarVisible with true value.
   *
   * @param state
   */
  showSidebar(state) {
    state.sidebarVisible = true;
  },

  /**
   * Toggle the menuUserNavBarVisible property. If menuUserNavBarVisible
   * is true, the new value will be false and if value is
   * false, the new value will be true.
   *
   * @param state
   */
  toggleMenuUserNavBarVisible(state) {
    state.menuUserNavBarVisible = !state.menuUserNavBarVisible;
  },

  /**
   * Hide menu user nav bar defining the property
   * menuUserNavBarVisible with false value.
   *
   * @param state
   */
  hideMenuUserNavBar(state) {
    state.menuUserNavBarVisible = false;
  },

  setDashboardConfig(state, config) {
    state.dashboardConfig = config;
  },
};

export default mutations;
